import { createStore, applyMiddleware, compose } from "redux";
import thunkMiddleware from "redux-thunk";
import { createLogger } from "redux-logger";
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage' 

import rootReducer from "./reducers";

const persistConfig = {
    key: 'aurora-0.14.0-pre4',
    storage,
  }
const persistedReducer = persistReducer(persistConfig, rootReducer)

const middlewares = [thunkMiddleware];
if (process.env.NODE_ENV !== "production") middlewares.push(createLogger());
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(persistedReducer, /* preloadedState, */ composeEnhancers(
    applyMiddleware(...middlewares)
));
const persistor = persistStore(store)

export { persistor, store }
